import React, { createContext, useContext, useState } from "react";
import { endpoints } from "@/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("c4b_user");
    return raw ? JSON.parse(raw) : null;
  });

  const login = async (email, password) => {
    const data = await endpoints.login({ email, password });
    localStorage.setItem("c4b_token", data.token);
    localStorage.setItem("c4b_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("c4b_token");
    localStorage.removeItem("c4b_user");
    setUser(null);
  };

  const setSession = (data) => {
    localStorage.setItem("c4b_token", data.token);
    localStorage.setItem("c4b_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
